import { render, staticRenderFns } from "./AxDeviceBox.vue?vue&type=template&id=4c49926c&scoped=true"
import script from "./AxDeviceBox.vue?vue&type=script&lang=ts"
export * from "./AxDeviceBox.vue?vue&type=script&lang=ts"
import style0 from "./AxDeviceBox.vue?vue&type=style&index=0&id=4c49926c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c49926c",
  null
  
)

export default component.exports